<div class="page" *ngIf="data() as d">
<app-page-site-switcher></app-page-site-switcher>
<div class="card dashboard-card">

  <!-- ══════ BANDEAU SITE — POSTE DE CONTRÔLE ══════ -->
  <div class="site-banner" [ngClass]="'banner-' + tensionClass">
    <div class="banner-top">
      <h1 class="banner-site">{{ establishmentName | uppercase }}</h1>
      <span class="banner-time">{{ currentTime() }}</span>
    </div>
    <div class="banner-bottom">
      <span class="banner-tension" [ngClass]="tensionClass">
        <span class="banner-dot" [ngClass]="tensionClass"></span>
        {{ tensionLabel | uppercase }}
      </span>
      <div class="banner-meta">
        <span class="banner-live">
          <span class="banner-live-dot"></span>
          {{ 'pilotage.supervision.banner.lastFrame' | translate: { time: lastFrameTimeStr(), delay: liveDelay() } }}
        </span>
        <span class="banner-source">{{ 'pilotage.supervision.banner.source' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- ══════ HEADER — 4 KPI ══════ -->
  <div class="header-row">

    <div class="hcard hcard-presence">
      <span class="hcard-presence-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="#ec4899" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="9" cy="7" r="4" stroke="#ec4899" stroke-width="2.5"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="#ec4899" stroke-width="2.5" stroke-linecap="round"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#ec4899" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="hcard-presence-title">{{ 'pilotage.supervision.kpi.presenceTitle' | translate }}</span>
      <span class="hcard-presence-sub">{{ 'pilotage.supervision.kpi.presenceSub' | translate }}</span>
      <span class="hcard-presence-value">≈ {{ d.header.patientsPresents }}</span>
      <span class="hcard-presence-delta" [class.green]="getLastDelta() <= 0" [class.red]="getLastDelta() > 0">
        {{ 'pilotage.supervision.kpi.presenceDelta' | translate: { delta: (getLastDelta() >= 0 ? '+' + getLastDelta() : getLastDelta()) } }}
      </span>
      <span class="hcard-frame-time" [ngClass]="frameAgeClass()">
        {{ 'pilotage.supervision.kpi.frameTime' | translate: { time: lastFrameTimeStr(), delay: liveDelay() } }}
      </span>
    </div>

    <div class="hcard hcard-passage" [class.hcard-passage-ok]="getAttenteEstimee() < 10" [class.hcard-passage-warn]="getAttenteEstimee() >= 10 && getAttenteEstimee() <= 30" [class.hcard-passage-danger]="getAttenteEstimee() > 30">
      <span class="hcard-passage-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="#513E9B" stroke-width="2.5"/>
          <path d="M12 7v5l3 3" stroke="#513E9B" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="hcard-passage-title">{{ 'pilotage.supervision.kpi.waitTitle' | translate }}</span>
      <span class="hcard-passage-sub">{{ 'pilotage.supervision.kpi.waitSub' | translate }}</span>
      <span class="hcard-passage-value">≈ {{ getAttenteEstimee() }} <small>min</small></span>
      <span class="hcard-passage-delta" [class.green]="d.header.chargeCapacite < 100" [class.red]="d.header.chargeCapacite > 100">
        <span *ngIf="d.header.chargeCapacite > 100">{{ 'pilotage.supervision.kpi.trendRising' | translate }}</span>
        <span *ngIf="d.header.chargeCapacite < 100">{{ 'pilotage.supervision.kpi.trendFalling' | translate }}</span>
        <span *ngIf="d.header.chargeCapacite === 100">{{ 'pilotage.supervision.kpi.trendStable' | translate }}</span>
      </span>
    </div>

    <div class="hcard hcard-charge" [class.hcard-charge-ok]="d.header.chargeCapacite < 80" [class.hcard-charge-warn]="d.header.chargeCapacite >= 80 && d.header.chargeCapacite <= 100" [class.hcard-charge-danger]="d.header.chargeCapacite > 100">
      <span class="hcard-charge-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#D97706" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17l10 5 10-5" stroke="#D97706" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12l10 5 10-5" stroke="#D97706" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="hcard-charge-title">{{ 'pilotage.supervision.kpi.loadTitle' | translate }}</span>
      <span class="hcard-charge-sub">{{ 'pilotage.supervision.kpi.loadSub' | translate }}</span>
      <span class="hcard-charge-value" [ngClass]="chargeClass">{{ d.header.chargeCapacite }}%</span>
    </div>

    <div class="hcard hcard-risque" *ngIf="d.header.chargeCapacite > 100">
      <span class="hcard-risque-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#DC2626" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="9" x2="12" y2="13" stroke="#DC2626" stroke-width="2.5" stroke-linecap="round"/>
          <line x1="12" y1="17" x2="12.01" y2="17" stroke="#DC2626" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </span>
      <span class="hcard-risque-title">{{ 'pilotage.supervision.kpi.riskTitle' | translate }}</span>
      <span class="hcard-risque-sub">{{ 'pilotage.supervision.kpi.riskSub' | translate }}</span>
      <span class="hcard-risque-value">{{ getRisqueDegradation() }}%</span>
    </div>

    <div class="hcard hcard-equilibre-card" *ngIf="d.header.chargeCapacite === 100">
      <span class="hcard-equilibre-icon">⚖️</span>
      <span class="hcard-equilibre-title">{{ 'pilotage.supervision.kpi.balanceTitle' | translate }}</span>
      <span class="hcard-equilibre-sub">{{ 'pilotage.supervision.kpi.balanceSub' | translate }}</span>
      <span class="hcard-equilibre-value">=</span>
    </div>

    <div class="hcard hcard-retour-card" *ngIf="d.header.chargeCapacite < 100">
      <span class="hcard-retour-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M23 12A11 11 0 1 1 12 1" stroke="#10B981" stroke-width="2.5" stroke-linecap="round"/>
          <path d="M12 8v4l3 3" stroke="#10B981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="hcard-retour-title">{{ 'pilotage.supervision.kpi.returnTitle' | translate }}</span>
      <span class="hcard-retour-sub">{{ 'pilotage.supervision.kpi.returnSub' | translate }}</span>
      <span class="hcard-retour-value">{{ getTempsRetourFluide() }} <small>min</small></span>
    </div>

  </div>

  <!-- ══════ ALERTE DÉCISIONNELLE ══════ -->
  <div class="alert-bar" [ngClass]="alertClass" *ngIf="d.alert.level !== 'vert'">
    <div class="alert-bar-left">
      <span class="alert-bar-icon" *ngIf="d.alert.level === 'rouge'">⚠️</span>
      <span class="alert-bar-icon" *ngIf="d.alert.level === 'orange'">⚡</span>
      <div class="alert-bar-text">
        <strong>{{ d.alert.titre }}</strong>
        <span>{{ d.alert.diagnostic }}</span>
      </div>
    </div>
    <div class="alert-bar-right">
      <span class="alert-bar-reco">{{ 'pilotage.supervision.alert.recommendations' | translate }}</span>
      <div class="alert-bar-actions">
        <button class="alert-badge alert-badge-primary" *ngIf="primaryAction as pa" (click)="executeAction(pa.type)" [disabled]="actionLoading() === pa.type">
          {{ pa.label }}
        </button>
        <button class="alert-badge" *ngFor="let a of secondaryActions" (click)="executeAction(a.type)" [disabled]="actionLoading() === a.type">
          {{ a.label }}
        </button>
      </div>
    </div>
  </div>

  <div class="alert-bar alert-bar-vert" *ngIf="d.alert.level === 'vert'">
    <div class="alert-bar-left">
      <span class="alert-bar-icon">✅</span>
      <div class="alert-bar-text">
        <strong>{{ 'pilotage.supervision.alert.flowNormal' | translate }}</strong>
        <span>{{ 'pilotage.supervision.alert.noTensionDetected' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- ══════ ANALYSE : Flux | Salles + Alertes ══════ -->
  <div class="center-grid">

    <!-- BLOC FLUX — TABLEAU -->
    <div class="block">
      <div class="flux-header">
        <h3>{{ 'pilotage.supervision.fluxTable.title' | translate }}</h3>
        <div class="flux-header-right">
          <span class="flux-last-frame" *ngIf="lastFrameTimeStr() !== '—'">
            {{ 'pilotage.supervision.fluxTable.lastFrame' | translate }} <strong>{{ lastFrameTimeStr() }}</strong>
          </span>
          <span class="flux-capacite-badge">{{ 'pilotage.supervision.fluxTable.capacityBadge' | translate: { value: getCapaciteActive() } }}</span>
        </div>
      </div>

      <table class="flux-table">
        <thead>
          <tr>
            <th>{{ 'pilotage.supervision.fluxTable.hourColumn' | translate }}</th>
            <th class="col-in">{{ 'pilotage.supervision.fluxTable.inColumn' | translate }}</th>
            <th class="col-out">{{ 'pilotage.supervision.fluxTable.outColumn' | translate }}</th>
            <th class="col-delta">Δ</th>
            <th class="col-cumul">{{ 'pilotage.supervision.fluxTable.cumulColumn' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of d.flux.entries; let i = index" [class.row-accumulation]="e.entrees > e.sorties" [class.row-resorption]="e.entrees < e.sorties">
            <td class="cell-time">{{ e.time }} - {{ getEndTime(e.time) }}</td>
            <td class="cell-in">{{ e.entrees }}</td>
            <td class="cell-out">{{ e.sorties }}</td>
            <td class="cell-delta" [class.delta-pos]="e.entrees > e.sorties" [class.delta-neg]="e.entrees < e.sorties">
              {{ e.entrees - e.sorties > 0 ? '+' : '' }}{{ e.entrees - e.sorties }}
            </td>
            <td class="cell-cumul" [class.cumul-pos]="getCumulAt(i) > 0" [class.cumul-neg]="getCumulAt(i) < 0">
              {{ getCumulAt(i) > 0 ? '+' : '' }}{{ getCumulAt(i) }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Résumé -->
      <div class="flux-resume">
        <div class="flux-resume-item" [class.red]="d.flux.tendance.startsWith('+')" [class.green]="d.flux.tendance.startsWith('-')">
          <span *ngIf="d.flux.tendance.startsWith('+')">{{ 'pilotage.supervision.fluxTable.accumulation' | translate }} · {{ d.flux.tendance }}</span>
          <span *ngIf="d.flux.tendance.startsWith('-')">{{ 'pilotage.supervision.fluxTable.recovery' | translate }} · {{ d.flux.tendance }}</span>
          <span *ngIf="!d.flux.tendance.startsWith('+') && !d.flux.tendance.startsWith('-')">{{ 'pilotage.supervision.flux.trendStable' | translate }}</span>
        </div>
        <div class="flux-resume-cumul" *ngIf="getTotalCumul() !== 0">
          {{ 'pilotage.supervision.fluxTable.balance2h' | translate }} <strong [class.red]="getTotalCumul() > 0" [class.green]="getTotalCumul() < 0">{{ 'pilotage.supervision.fluxTable.patientsCount' | translate: { count: (getTotalCumul() > 0 ? '+' + getTotalCumul() : getTotalCumul()) } }}</strong>
        </div>
      </div>
    </div>

    <!-- BLOC PRODUCTION -->
    <!-- COLONNE DROITE : Production + Alertes -->
    <div class="right-col">

    <div class="block">
      <h3>{{ 'pilotage.supervision.production.title' | translate }} <span class="prod-live">{{ 'pilotage.supervision.production.live' | translate }}</span></h3>
      <div class="prod-rows">
        <div class="prod-row" *ngFor="let s of d.production.salles" [class.row-anomalie]="s.anomalie">
          <span class="prod-nom">{{ s.nom }}</span>
          <span class="prod-debit" *ngIf="s.occupation >= 70 || s.anomalie">{{ 'pilotage.supervision.production.throughput' | translate: { value: (s.debit / 4 | number:'1.0-1') } }}</span>
          <span class="prod-debit prod-fermee" *ngIf="s.occupation < 70 && !s.anomalie">{{ 'pilotage.supervision.production.closedThroughput' | translate }}</span>
          <span class="prod-status">
            <span class="prod-badge prod-badge-lent" *ngIf="s.anomalie">{{ 'pilotage.supervision.production.slowdown' | translate }}</span>
          </span>
        </div>
      </div>
      <div class="prod-capacite">
        {{ 'pilotage.supervision.production.activeCapacity' | translate }} <strong>{{ 'pilotage.supervision.production.activeCapacityValue' | translate: { value: getCapaciteActive() } }}</strong>
      </div>
    </div>

    <!-- BLOC ALERTES ACTIVES -->
    <div class="block">
      <h3>{{ 'pilotage.supervision.alertsList.title' | translate }} · <span class="alertes-count">{{ (getAlertesActives().length === 1 ? 'pilotage.supervision.alertsList.countOne' : 'pilotage.supervision.alertsList.count') | translate: { count: getAlertesActives().length } }}</span></h3>
      <div class="alertes-list">
        <div class="alerte-row" *ngFor="let a of getAlertesActives()">
          <span class="alerte-dot" [ngClass]="a.color"></span>
          <span class="alerte-text">{{ a.message }}</span>
          <span class="alerte-badge" [ngClass]="a.status">{{ a.statusLabel }}</span>
        </div>
      </div>
    </div>

    </div><!-- /right-col -->

  </div>

</div>
</div>

<div class="page loading-state" *ngIf="loading()"><p>{{ 'pilotage.supervision.states.loading' | translate }}</p></div>
